import {postUpdatePoints} from '../api/postUpdatePoints';
import { setGetViewTournamentStat } from './setGetViewTournamentStat';

const setPostUpdatePoints = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdatePoints(params);
            dispatch(setGetViewTournamentStat({id_tournament: params.id_tournament}))
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdatePoints
}